import { Localize } from '@biniyog/localize';
import { ExternalFooter } from '@biniyog/shared/external-footer';
import { ExternalNavBar } from '@biniyog/shared/external-navbar';
import '../../../../../../../../libs/ui/src/lib/cssOverrides/antd.scss';
import notFoundImage from '../../../../assets/images/not-found.png';
import '../../internal/internal.scss';

export default function NotFound() {
  return (
    <Localize>
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', minHeight: '100vh' }}>
        <ExternalNavBar />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            gap: 24,
            padding: '24px 24px',
          }}
        >
          <img src={notFoundImage} alt="" />
          <div style={{ display: 'flex', gap: 12, flexDirection: 'column' }}>
            <h2>404 - Page not found!</h2>
            <p style={{ fontSize: '16px', textAlign: 'center' }}>
              The page you’re looking for might have been removed or it’s temporary unavailable.
            </p>
          </div>
        </div>
        <ExternalFooter />
      </div>
    </Localize>
  );
}
